import emptyReducer from './emptyReducer';

const fromLbsToKg = (weightLb: number) => `${Math.round(weightLb * 0.453592)}kg`;

const toWeight = emptyReducer<string | null>(null).with({
  BodyMassIndex: (heightFt, heightIn, weightLb) => (weightLb ? fromLbsToKg(weightLb) : null),
});

export default toWeight;
